module.exports = __webpack_public_path__ + "img/pro_five_12.a7c4e508.jpg";